import React, { useState } from 'react';
import '../styles/Navbar.css';

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    element.scrollIntoView({ behavior: 'smooth' });
    setIsOpen(false); // Close menu after clicking
  };

  return (
    <nav className="navbar" role="navigation" aria-label="Main navigation">
      <div className="navbar-brand">
        <button onClick={() => scrollToSection('home')} aria-label="Go to home section">trickledown.fail</button>
      </div>
      <button 
        className={`hamburger ${isOpen ? 'open' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Toggle menu"
        aria-expanded={isOpen}
      >
        <span></span>
        <span></span>
        <span></span>
      </button>
      <div className={`navbar-links ${isOpen ? 'open' : ''}`} role="menu">
        <button onClick={() => scrollToSection('home')} role="menuitem" aria-label="Navigate to home section">Home</button>
        <button onClick={() => scrollToSection('billionaire-impact')} role="menuitem" aria-label="Navigate to failed theory section">Failed Theory</button>
        <button onClick={() => scrollToSection('live-wealth')} role="menuitem" aria-label="Navigate to live tracker section">Live Tracker</button>
        <button onClick={() => scrollToSection('wealth-comparison')} role="menuitem" aria-label="Navigate to wealth gap section">Wealth Gap</button>
        <button onClick={() => scrollToSection('solutions')} role="menuitem" aria-label="Navigate to take action section">Take Action</button>
      </div>
    </nav>
  );
}

export default Navbar; 